import { render, staticRenderFns } from "./PhoneStepModule.vue?vue&type=template&id=ad60a474"
import script from "./PhoneStepModule.vue?vue&type=script&lang=js"
export * from "./PhoneStepModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports